import Modal from "./Modal";
import ModalReason from "./ModalReason";

export { Modal, ModalReason };
